<template>
    <v-app>
        <v-container>
            <v-row>
                <v-col>
                    <v-textarea
                        v-model="graficas"
                        outlined
                        label="JSON Graficas"
                        height="400"
                        no-resize
                        :error-messages="erroresGraficas"
                        @focus="erroresGraficas = []"
                        @input="erroresGraficas = []"
                    >
                    </v-textarea>
                    <v-btn @click="jsonBonitoGraficas()"> Formatear </v-btn>
                </v-col>
                <v-col>
                    <v-textarea
                        v-model="datos"
                        outlined
                        label="JSON Datos"
                        height="400"
                        no-resize
                        :error-messages="erroresDatos"
                        @focus="erroresDatos = []"
                        @input="erroresDatos = []"
                    >
                    </v-textarea>
                    <v-btn @click="jsonBonitoDatos()"> Formatear </v-btn>
                </v-col>
            </v-row>
            <v-row align="end">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="generarGraficas()">
                    Generar Graficas
                </v-btn>
            </v-row>
            <v-row> <v-divider></v-divider></v-row>
            <v-row justify="center" v-if="graficasCargadas">
                <v-col
                    v-for="(grafica, index) in array_graficas"
                    :key="index"
                    cols="12"
                    :md="grafica.columnas"
                >
                    <v-card
                        outlined
                        class="mx-auto"
                        rounded="lg"
                        :elevation="elevacion_cards"
                    >
                        <v-card-title class="titulo-detalle" v-text="grafica.descripcion">
                        </v-card-title>
                        <v-card-text>
                            <MostrarGrafica
                                :tipo="grafica.tipo"
                                :datos_grafica="grafica.datos_grafica"
                            >
                            </MostrarGrafica>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import MostrarGrafica from "@components/MostrarGrafica.vue";
import GraficasService from "@services/GraficasService";

export default {
    name: "TestGraficas",
    components: { MostrarGrafica },
    data: () => ({
        graficas: "",
        erroresGraficas: [],
        datos: "",
        erroresDatos: [],
        graficasCargadas: false,
        array_graficas: [],
    }),
    methods: {
        generarGraficas() {
            this.graficasCargadas = false;
            this.array_graficas = [];
            GraficasService.testGraficas({ datos: this.datos, graficas: this.graficas })
                .then((response) => {
                    this.array_graficas = response.data;
                })
                .catch((e) => {
                    if ("graficas" in e.response.data.errors) {
                        this.erroresGraficas = ["No es un JSON valido"];
                    }

                    if ("datos" in e.response.data.errors) {
                        this.erroresDatos = ["No es un JSON valido"];
                    }
                })
                .finally(() => {
                    this.graficasCargadas = true;
                });
        },
        jsonBonitoGraficas() {
            try {
                this.graficas = JSON.stringify(JSON.parse(this.graficas), undefined, 4);
            } catch (e) {
                this.erroresGraficas = ["No es un JSON valido"];
            }
        },
        jsonBonitoDatos() {
            try {
                this.datos = JSON.stringify(JSON.parse(this.datos), undefined, 4);
            } catch (e) {
                this.erroresDatos = ["No es un JSON valido"];
            }
        },
    },
};
</script>

<style>
.titulo-detalle {
    word-break: break-word;
}
</style>
